import { HtmlPreview } from "@/components/ui/custom/dataDisplay/HtmlPreview";
import ConditionalRenderer from "@/components/ui/custom/ConditionalRenderer";
import { flashcardPreviewClass } from "./FlashcardStack";
import { twMerge } from "tailwind-merge";

type BackFlashcardProps = {
  frontContent: string;
  backContent: string;
  showFrontOnBack: boolean;
};

export function BackFlashcard({
  frontContent,
  backContent,
  showFrontOnBack,
}: BackFlashcardProps) {
  return (
    <>
      <ConditionalRenderer condition={showFrontOnBack && frontContent}>
        <HtmlPreview
          format="default"
          html={frontContent}
          className={twMerge(flashcardPreviewClass, '[&_p]:font-semibold')}
        />
      </ConditionalRenderer>
      <HtmlPreview
        format="default"
        html={backContent}
        className={twMerge(
          flashcardPreviewClass,
          '[&_p]:text-primary [&_p]:text-2xl',
        )}
      />
    </>
  );
}
